import i18n from "i18next";
import { z } from "zod";
import { notificationSchema } from "../utils";

const LANG_BASE = "vessel-call.port-services.fields";

export const approveByOperationsShipChandlingSchema = () => {
  const chargedPartyLabel = i18n.t(`${LANG_BASE}.charged-party`);

  const chargedPartySchema = z.object({
    chargedParty: z.preprocess(
      (value) => {
        if (value === "" || value === null || value === undefined) {
          return undefined;
        }

        return value;
      },
      z
        .string({
          required_error: i18n.t("form-validation.required", { label: chargedPartyLabel }),
          invalid_type_error: i18n.t("form-validation.required", { label: chargedPartyLabel }),
        })
        .min(1, i18n.t("form-validation.required", { label: chargedPartyLabel }))
        .refine((value) => ["VESSEL", "SUPPLY_BOAT"].includes(value), {
          message: i18n.t("form-validation.required", { label: chargedPartyLabel }),
        }),
    ),
  });

  const notesSchema = z.object({
    notes: z
      .string()
      .max(
        1000,
        i18n.t("form-validation.max-length", {
          label: i18n.t(`${LANG_BASE}.internal-notes`),
          max: 1000,
        }),
      )
      .optional(),
    attachment: z.any().optional(),
  });

  return chargedPartySchema.merge(notesSchema).merge(notificationSchema);
};

export type ApproveByOperationsShipChandlingSchema = z.infer<
  ReturnType<typeof approveByOperationsShipChandlingSchema>
>;
